import type { HelpFile } from '../../types/help'
import { NotificationBellTestIds } from '../../../testids/NotificationBellTestIds'

export const notificationBellHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [NotificationBellTestIds.notificationBell]: null,
    [NotificationBellTestIds.unreadBadge]: null,
    [NotificationBellTestIds.markAllRead]:
      'Mark every visible notification as read at once.',
    [NotificationBellTestIds.viewAllNotifications]:
      'Open the full notification history with filters and details.',
  },
}
